import type { Me } from "../api/getMe";

export interface AccountDisplay {
  /** Best display name: the user's name, falling back to their email. */
  name: string;
  /** Single uppercase letter for the avatar. */
  initial: string;
  /** Human plan label from the backend ("Free" | "Pro" | "Max"). */
  planName: Me["plan_name"];
  /** Plan id, for gating upgrade affordances. */
  planId: Me["plan_id"];
}

/**
 * Derive the presentational bits of an account row from the raw `me` payload.
 * Pure (no React, no i18n) so the footer + Account settings share one source of
 * truth and the fallbacks are unit-testable.
 */
export function accountDisplay(me: Me): AccountDisplay {
  const trimmedName = me.name.trim();
  const name = trimmedName || me.email;
  const initial = (name[0] ?? "?").toUpperCase();
  return { name, initial, planName: me.plan_name, planId: me.plan_id };
}
